<template>
	<div class="login">
		<div class="box">
			<div class="title">雀巢消费者服务中心</div>
			<div class="number">
				<el-input v-model="account" placeholder="请输入工号"></el-input>
			</div>
			<div class="password">
				<el-input
					v-model="password"
					placeholder="请输入密码"
					show-password
				></el-input>
			</div>
			<a class="btn" @click="onSubmit" v-preventReClick>登录</a>
		</div>
	</div>
</template>

<script>
import preventReClick from '@/utils/preventReClick'
import { isPasswd } from '@/utils/checkHelper'
import { Base64 } from 'js-base64'
import CryptoJS from 'crypto-js';

export default {
	name: 'login',
	props: [],
	data() {
		return {
			account: '',
			password: '',
		}
	},
	watch: {},
	mounted: function () {
		var userAgent = navigator.userAgent
		var isChrome = navigator.userAgent.indexOf('Chrome') > -1
		if (!isChrome) {
			this.$confirm('请使用谷歌浏览器', '提示', {
				confirmButtonText: '确定',
				type: 'error',
				closeOnPressEscape: false,
				closeOnClickModal: false,
				showClose: false,
				showCancelButton: false,
				showConfirmButton: false,
			})
			return
		}
		if (top.location !== self.location) {
			top.location.href = self.location.href
		}

		if (this._globle.timing != null) {
			window.clearInterval(this._globle.timing)
		}
		if (this._globle.resend != null) {
			window.clearInterval(this._globle.resend)
		}
	},
	methods: {
		onSubmit() {
			if (this.account == '' || this.account == undefined) {
				this.$message.error('请输入账号和密码')
				return
			}
			debugger
			// else if (this.password.length < 6) {
			// 	this.$message.error('密码不能少于6位')
			// 	return
			// }

			// let isTrue = isPasswd(this.password)
			// if (!isTrue) {
			// 	this.$confirm(
			// 		'密码格式错误、必须包含大小写字母数字和特殊符号、长度8-12位',
			// 		'错误',
			// 		{
			// 			confirmButtonText: '确定',
			// 			type: 'error',
			// 			showCancelButton: false
			// 		}
			// 	)
			// 	return
			// }
			let $this = this
			var account = $this.encryptECB($this.account);
			var password = $this.encryptECB($this.password);
			this.axios
				.post('login', {
					account:  account,
					password: password,
				},{Headers:{auditChannel:Base64.encode(`用户登录:${$this.account}`)}})
				.then(function ({ data }) {
					let json = JSON.stringify(data.data)
					if (data.result) {
						localStorage.clear()
						localStorage.setItem(
							'defaultKfHeadimg',
							data.data.headimg
						)
						localStorage.setItem(
							'defaultConsultHeadimg',
							data.data.consultHeadimg
						)
						localStorage.clear
						localStorage.setItem($this.LoginInfo, json) //写入缓存
						localStorage.setItem('Terst', $this.account)
						$this.$message.success(data.message)
						
						if(data.data.aboutToExpire && data.data.roleId!=4)
						{
						 $this.$confirm(data.data.expireTip, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
							distinguishCancelAndClose:true,
							closeOnClickModal:false
							}).then(() => {
								 
								$this.$router.push({path:'/customs/setting?type=1'})
							}).catch(() => {
						 });
						}
						$this._globle.firstLoginKey = data.data.initialPasswordNotChanged;//是否初始密码登录
						if(data.data.roleId==4){
							$this.$router.push({path:'/manage/auditList'})
						}else{
							$this.$router.push({ path: '/customs/talks' }) //登录成功跳转页面
						}
				
					} else {
						debugger
						$this.$message.error(data.message)
					}
				})
		},
		encryptECB(plaintText) {
			var plaintText = plaintText;
			var options = {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7
			};
			var key = CryptoJS.enc.Utf8.parse("e0YDC3vNOWhtY7Qy"); //秘钥
			var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
			var encryptedBase64Str = encryptedData.toString();
			return encryptedBase64Str;
		}
 
	},
}
</script>
<style scoped>
.login {
	width: 100%;
	height: 100%;
	background: url(../assets/back.jpg) no-repeat center top;
	background-size: 100%;
}
.box {
	width: 48%;
	float: right;
	text-align: center;
	padding-top: 300px;
}
.title {
	font-size: 22px;
	font-weight: bold;
}
.number {
	width: 430px;
	margin: 90px auto 45px;
}
.password {
	width: 430px;
	margin: 0 auto 0;
}
.btn {
	display: block;
	width: 430px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	color: #fff;
	font-size: 18px;
	background-color: #5092e1;
	margin: 150px auto 0;
}
</style>
<style scoped>
.el-input {
	width: 100%;
}
.number .el-input__inner {
	width: 100%;
	height: 50px;
	background-color: transparent;
}
.password .el-input__inner {
	width: 100%;
	height: 50px;
	background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue